import {
  SET_UNNAX_DOCUMENT_BACK,
  SET_UNNAX_DOCUMENT_FRONT,
} from '../actions/unnaxTypes';

const unnaxInitialState = {
  unnaxDocument: {},
};

export const unnaxFrontDocument = (
  state = unnaxInitialState.unnaxDocument,
  action
) => {
  switch (action.type) {
    case SET_UNNAX_DOCUMENT_FRONT:
      return action.file;
    default:
      return state;
  }
};

export const unnaxBackDocument = (
  state = unnaxInitialState.unnaxDocument,
  action
) => {
  switch (action.type) {
    case SET_UNNAX_DOCUMENT_BACK:
      return action.file;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/unnaxReducer.js